import React from 'react';
import './styles.css';
import { Alert, Badge, Row, Col, Avatar } from 'antd';

const ItemList = ({
  count,
  src,
  title,
  description,
  url,
  download,
  isParticipantTerminated,
  isActiveSociogram,
  message,
  buttonModal,
}) => {
  return (
    <Row className="itemList-container" type="flex" align="middle">
      <Col span={4}>
        <span className="avatar-item">
          <Badge count={count} size="default">
            <Avatar
              size={{ xs: 24, sm: 32, md: 40, lg: 64, xl: 80, xxl: 100 }}
              src={src}
            />
          </Badge>
        </span>
      </Col>

      <Col span={20}>
        {/* {isActiveSociogram ? (
          <div>
            <Alert message={message} type="info" showIcon />
            {buttonModal}
          </div>
        ) : */}
        {isParticipantTerminated ? (
          <Alert message={message} type="info" showIcon />
        ) : (
          <div>
            <h3 className="itemList-container_title">{title}</h3>
            <p>
              {description} {url} {download}
            </p>
            {isActiveSociogram ? <div>{buttonModal}</div> : null}
          </div>
        )}
      </Col>
    </Row>
  );
};

export default ItemList;
